/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AsyncJobStatus {
    SCHEDULED = 'scheduled',
    IN_PROGRESS = 'inProgress',
    DONE = 'done',
    FAILED = 'failed',
    CANCELED = 'canceled',
}
